import styled from 'styled-components';

import { Link } from '@dreryk/react-components';

export const StyledTimeSinceLastVisitValue = styled.strong`
   font-weight: bold;
   color: ${(props) => props.theme.primary};
`;

StyledTimeSinceLastVisitValue.displayName = 'StyledTimeSinceLastVisitValue';

export const StyledTimeSinceLastVisitLink = styled(Link)`
   display: inline;
   font-weight: bold;
`;

StyledTimeSinceLastVisitLink.displayName = 'StyledTimeSinceLastVisitLink';
